<template>
  <div>
    <q-dialog v-model="show" @input="(val) => $emit('input', val)">
      <q-layout  container class="bg-white modal-medium">
        <q-header style="background-color: #3a4155">
          <q-toolbar>
            <q-toolbar-title>
              {{ $gettext("VIEW_INSTALLMENT") }}
            </q-toolbar-title>
            <q-btn v-close-popup @click="closeModal" flat round dense icon="close" />
          </q-toolbar>
        </q-header>
        <q-page-container>
          <q-card-section >
            <div >
           <jt-dynamic-form
              ref="dynamicForm"
              :inputs="formInfo.inputs"
              :relacionamentos="formInfo.relacionamentos"
              :model="formInfo.dadosForm"
              form-class="form"
              class=" q-pr-lg q-pl-lg jtExtensionModalForm"
              interface='agreementInstallmentExtension.createInstallmentExtension'
              @search-found="
                (event) => {
                  $emit('search-found', event);
                }
              "
              @on-select-change="
                (event) => {
                  $emit('on-select-change', event);
                }
              "
              @on-select-ajax="
                (event) => {
                  $emit('on-select-ajax', event);
                }
              "
              @input="onInput"
            />
            </div>
            <div class="tw-w-full tw-flex tw-justify-center">
              <q-btn @click="recalculate" class="tw-bg-skyWaste tw-text-white">
                {{$gettext("RECALCULATE")}}
              </q-btn>
            </div>
            <div class="tw-py-2">
            {{ this.$gettext("EXTENSION_SUMMARY") }}
          </div>

          <q-separator />
          <div class="tw-flex tw-gap-6 tw-p-4">
            <div class="tw-w-1/3 custom-border tw-p-2">
              <div class="row-detail">
                <span class="text-subtitle2 bg-ice box-label">
                  {{ $gettext("ORIGINAL_TOTAL") }}:
                  <span class="text-subtitle1">{{
                    $toLocaleStringBr(extensionValues.originalAmount)
                  }}</span>
                </span>
              </div>
              <div class="row-detail">
                <span class="text-subtitle2 box-label">
                  {{ $gettext("INTEREST_VALUE") }}:
                  <span class="text-subtitle1">{{
                    $toLocaleStringBr(extensionValues.interestAmount)
                  }}</span>
                </span>
              </div>
              <div class="row-detail">
                <span class="text-subtitle2 bg-ice box-label">
                  {{ $gettext("PENALTY_VALUE") }}:
                  <span class="text-subtitle1">{{
                    $toLocaleStringBr(extensionValues.fineAmount)
                  }}</span>
                </span>
              </div>
              <div class="row-detail">
                <span class="text-subtitle2 box-label">
                  {{ $gettext("CORRECTION_VALUE") }}:
                  <span class="text-subtitle1">{{ $toLocaleStringBr(extensionValues.correctionAmount)}}</span>
                </span>
              </div>
              <div class="row-detail observation">
                <span class="text-subtitle2 bg-ice box-label"> </span>
              </div>
            </div>
            <div class="tw-w-1/3 custom-border tw-p-2">
              <div class="row-detail">
                <span class="text-subtitle2 bg-ice box-label">
                  {{ $gettext("CORRECTED_TOTAL") }}:
                  <span class="text-subtitle1">{{
                    $toLocaleStringBr(extensionValues.totalAmount)
                  }}</span>
                </span>
              </div>
              <div class="row-detail">
                <span class="text-subtitle2 box-label">
                  {{ $gettext("INTEREST_DISCOUNT_VALUE") }}:
                  <span class="text-subtitle1">{{
                    $toLocaleStringBr(extensionValues.interestAmountDiscount)
                  }}</span>
                </span>
              </div>
              <div class="row-detail">
                <span class="text-subtitle2 bg-ice box-label">
                  {{ $gettext("FINE_DISCOUNT_VALUE") }}:
                  <span class="text-subtitle1">{{
                    $toLocaleStringBr(extensionValues.fineAmountDiscount)
                  }}</span>
                </span>
              </div>
              <div class="row-detail observation bg-">
                <span class="text-subtitle2 box-label">
                  {{ $gettext("CORRECTION_DISCOUNT_VALUE") }}:
                  <span class="text-subtitle1">{{
                    $toLocaleStringBr(extensionValues.correctionAmountDiscount)
                  }}</span>
                </span>
              </div>
              <div class="row-detail observation">
                <span class="text-subtitle2 bg-ice box-label"> </span>
              </div>
            </div>
            <div class="tw-w-1/3  custom-border tw-p-2">
              <div class="row-detail">
                <span class="text-subtitle2 bg-ice box-label">
                  {{ $gettext("TOTAL_DISCOUNTS") }}:
                  <span class="text-subtitle1">{{
                    $toLocaleStringBr(extensionValues.totalAmountDiscounts)
                  }}</span>
                </span>
              </div>
            </div>
          </div>
          <q-separator />
            <div class="row justify-evenly tw-gap-6 tw-p-4">
              <q-btn class="col-4" size="md" color="grey-7" @click="closeModal">{{
                $gettext('CANCEL')
              }}</q-btn>
              <q-btn
                :disable="disableSaveButton"
                class="col-4"
                size="md"
                :color="disableSaveButton ? 'grey-7':'info'"
                @click="onSaveHandler"
                >{{ $gettext('RECORD') }}</q-btn
              >
            </div>
            </q-card-section>
        </q-page-container>
      </q-layout>
    </q-dialog>
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud, JtDynamicForm } from 'jtech-webcomps'
const { page } = JtCrud
import { repository, messageBox } from 'src/jtech'
import { QDialog, Dialog } from 'quasar'
import moment from 'moment'
import { isLate, calculateLateDays } from 'src/shared/global/UtilDate'

@Component({
  mixins: [page],
  name: 'InstallmentExtensionModal',
  components: {
    page,
    QDialog,
    Dialog,
    JtDynamicForm
  },
  props: {
    show: {
      type: Boolean,
      default: true
    },
    selectedRow: {
      type: Object
    }
  }
})
class InstallmentExtensionModal extends Vue {
  moment = moment;
  dataColumns = [];
  disableSaveButton = false;
  extensionValues = {
    fineAmount: 0.0,
    interestAmount: 0.0,
    correctionAmount: 0.0,
    originalAmount: 0.0,
    totalAmount: 0.0,
    fineAmountWithDiscount: 0.0,
    interestAmountWithDiscount: 0.0,
    correctionAmountWithDiscount: 0.0,
    totalAmountWithDiscount: 0.0,
    fineAmountDiscount: 0.0,
    interestAmountDiscount: 0.0,
    correctionAmountDiscount: 0.0,
    totalAmountDiscounts: 0.0
  }

  get formInfo () {
    return this.dataColumns.length > 0 ? this.dataColumns[0] : {}
  }

  onInput (a, b, c) {
    console.log('a', a, 'b', b, 'c', c)
    this.disableSaveButton = true
  }

  closeModal () {
    this.$emit('close-modal')
  }

  async mounted () {
    this.dataColumns = await repository.resolve(
      'agreementInstallmentExtension.createInstallmentExtension'
    )
    const extensionOriginalValues = await repository.resolveLogic('agreementInvoice.getExtensionValues', { invoiceDocument: this.selectedRow.invoiceDocument })
    Object.assign(this.extensionValues, extensionOriginalValues)
  }

  async recalculate () {
    if (this.isInvalidForm()) {
      console.log(isLate(this.formInfo.dadosForm.newDueDate))
      if (isLate(this.formInfo.dadosForm.newDueDate) ||
      (!isLate(this.formInfo.dadosForm.newDueDate) && calculateLateDays(this.formInfo.dadosForm.newDueDate) === 0)) {
        messageBox.warn(this.$gettext('EXTENDING_DATE_SMALLER_THAN_ACTUAL'))
      }
      if (this.isDiscountBiggerThanLimit()) {
        messageBox.warn(this.$gettext('DISCOUNT_PERCENTAGE_INVALID'))
      }
      if (calculateLateDays(this.formInfo.dadosForm.newDueDate) > 60) {
        messageBox.warn(this.$gettext('EXTENDING_DATE_TOO_LATE'))
      }
      return
    }
    const correctedExtensionValues = await repository.resolveLogic('agreementInvoice.getExtensionValuesWithDiscount', {
      ...this.extensionValues,
      fineDiscountPercentage: this.formInfo.dadosForm.fineDiscountPercentage,
      interestDiscountPercentage: this.formInfo.dadosForm.interestDiscountPercentage,
      correctionDiscountPercentage: this.formInfo.dadosForm.correctionDiscountPercentage
    })
    Object.assign(this.extensionValues, correctedExtensionValues)
    this.disableSaveButton = false
  }

  isInvalidForm () {
    return this.isDiscountBiggerThanLimit() ||
     isLate(this.formInfo.dadosForm.newDueDate) || calculateLateDays(this.formInfo.dadosForm.newDueDate) > 60 ||
     (!isLate(this.formInfo.dadosForm.newDueDate) && calculateLateDays(this.formInfo.dadosForm.newDueDate) === 0)
  }

  isDiscountBiggerThanLimit () {
    return this.formInfo.dadosForm.fineDiscountPercentage > 100 || this.formInfo.dadosForm.interestDiscountPercentage > 100 ||
    this.formInfo.dadosForm.correctionDiscountPercentage > 100
  }

  async onSaveHandler () {
    if (this.$refs.dynamicForm.isValidForm()) {
      if (isLate(this.formInfo.dadosForm.newDueDate)) {
        messageBox.warn(this.$gettext('EXTENDING_DATE_SMALLER_THAN_ACTUAL'))
      } else {
        await repository.create('agreementInstallmentExtension.createInstallmentExtension', {
          ...this.formInfo.dadosForm,
          ...this.extensionValues,
          invoiceDocument:
        this.selectedRow.invoiceDocument,
          agreementInvoice: this.selectedRow.agreementInvoice
        })
        this.$nextTick(async () => {
          this.$emit('close-modal')
          this.$emit('refresh-table')
        })
      }
    }
  }
}

export default InstallmentExtensionModal
</script>
<style lang="scss">
@import "tailwindcss/utilities";

  .jtExtensionModalForm {
    #scroll-area {
      height: calc(30vh - 12px) !important;
      .q-scrollarea__content{
        position: relative !important;
      }
    }
  }

  .custom-border {
    border: 0.5px solid #ccc;
    border-radius: 4px;
  }

  .row-detail {
    display: flex;
    height: 30px;
    width: 100%;
  }
  .box-label {
    width: 100%;
    padding-left: 10px;
    word-break: break-all;
  }
</style>
